module.exports = __webpack_public_path__ + "assets/img/eternia-41.4cfd2e03.jpg";